import styled from 'styled-components';

export const Container = styled.div`
  padding: 15px 10px;
  background-color: var(--primary);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  bottom: 0;
  width: 100%;
`;

export const Link = styled.a`
  display: flex;
  text-decoration: none;
`

export const Img = styled.img`
  display: ${props => props.MostrarMobile ? 'none' : 'flex' };
  height: 60px;

  @media(max-width: 600px) {
    display: ${props => props.MostrarMobile ? 'flex' : 'none' };
	}
`